import { render } from "./BlackjackGame.vue?vue&type=template&id=bfdb215a&scoped=true"
import script from "./BlackjackGame.vue?vue&type=script&lang=js"
export * from "./BlackjackGame.vue?vue&type=script&lang=js"

import "./BlackjackGame.vue?vue&type=style&index=0&id=bfdb215a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfdb215a"]])

export default __exports__